module.exports = __webpack_public_path__ + "img/PropietarioDatos.529151cc.svg";